<template>
  <div class="wrap">
    <com-title :subtitle="subtitle"></com-title>
    <div class="container">
      <ul class="content columns is-mobile">
        <li v-for="(item, index) in partners" :key="index" class="column is-one-fifth-tablet is-half-mobile">
          <a :href="item.link" target="_blank">
            <div class="img">
              <img :src="item.avatar">
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import comTitle from '@/base/ego-title'
export default {
  data () {
    return {}
  },
  components: {
    comTitle
  },
  props: ['partners', 'subtitle'],
  computed: {}
}
</script>
<style scoped lang='sass'>
@import "../../style/bulma/sass/utilities/_all"

.container
  padding-top: 30px
  +mobile
    padding: 20px 0 20px
    width: 88vw

div.wrap
  background-color: #f5f5f5
  padding-bottom: 80px
  +mobile
    padding-bottom: 0

  ul
    flex-wrap: wrap
    justify-content: center
    li
      margin-top: 0
      a
        display: flex
        justify-content: center
        align-items: center
        margin: 0 auto
        background-color: #fff
        box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
        .img
          width: 158px
          height: 98px
          display: flex
          justify-content: center
          align-items: center
          img
            width: 100%
            +mobile
              width: 140px
</style>
